import React, {useEffect} from 'react';
import Map from '../components/Map/Map';
import Intro from '../components/Intro/Intro';
import { useEffect } from 'react';

const Language = ({ inactivity, location }) => {

    // trigger tracking
    useEffect(() => {
        
        // perform tracking
        // gtag('event', 'screen_view', {
        //     'screen_name': 'language_choice'
        // });

        gtag('event', 'page_view', {
            page_path: '/language_choice'
        });

        // set inactivity functionality
        inactivity();

    }, []);

    // render html
    return(
        <>
            <Intro location={location} />
            <Map type="blur" />
        </>
    );
}

export default Language;